export const COLOR = {
  PRIMARY: { 
    50: '#fefdfe',
    100: '#fefdfe',
    200: '#f6c3d6',
    300: '#ef97b8',
    400: '#ea78a3',
    DEFAULT: '#e76294',
    500: '#e76294',
    600: '#e34782',
    700: '#df2d70',
    800: '#ce1f61',
    900: '#bb1453', 
  },
  SECONDARY: { 
    50: '#a4acd6',
    100: '#a4acd6',
    200: '#6677d1',
    300: '#3f54c5',
    400: '#3447ad',
    DEFAULT: '#2e3f99',
    500: '#2e3f99',
    600: '#273581',
    700: '#202c6a',
    800: '#192252',
    900: '#192252',
  },
  TERTIARY: {
    100: '#fce8e4',
    200: '#fad6ce',
    300: '#f5b9ac',
    400: '#ea816a',
    500: '#E16C52',
    DEFAULT: '#e16c52',
    600: '#cd5035',
  },
  WHITE_APP: '#FAF9FB',
  BLACK_APP: '#231838',
  GRAY_APP: {
    100: '#f0eff0',
    200: '#e3e2e3',
    300: '#d0cfd2',
    400: '#bdbbbe',
    500: '#b0aeb2',
    DEFAULT: '#b0aeb2',
    600: '#969398',
    700: '#817f83',
    800: '#6a686b',
  },
  DETAIL: '#F3F1FE',
  STEPPER_TITTLE: '#191919',
  STEPPER_SUB: '#636363',
  DISABLED: '#E7E7EA',
  WARNING: {
    DEFAULT: '#E8B931',
    SECONDARY: '#FFF1C2',
  },
  PAYMENT: {
    DEFAULT: '#000000',
    SECONDARY: '#F2F4F7',
  },
};
